import React from 'react';
import {shallowEqual, useSelector} from 'react-redux';
import {Footer} from "../../_common/components/Footer/Footer";

export const UsersActionsFooter = () => {
  const {count} = useSelector(
    (state) => ({count: state.usersActions.totalCount}),
    shallowEqual
  );

  return <Footer count={count}/>
};
